/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { API_ROOT } from '../constants/api';

// Reservations
export const reservationEndpoint = (resId) => `${API_ROOT}/reservations/${resId}`;
export const reminderEndpoint = () => `${API_ROOT}/reservations/purchase-reminder`;
export const reservationsEndpoint = (resIds = []) =>
    `${API_ROOT}/reservations${resIds.length ? `?id=${resIds.join('&id=')}` : ''}`;
export const priceEndpoint = () => `${reservationsEndpoint()}/price`;
export const validateEndpoint = () => `${reservationsEndpoint()}/validate`;
export const qrCodeEndpoint = (passId) => `${API_ROOT}/passes/${passId}/qr-code`;

// Pass Types
export const passTypeEndpoint = (passTypeId) => `${API_ROOT}/passtypes/${passTypeId}`;
export const passTypesEndpoint = (facilityId) =>
    `${API_ROOT}/passtypes/facility/${facilityId}`;

// Facilities
export const facilitiesEndpoint = () => `${API_ROOT}/facilities`;
export const facilityEndpoint = (facilityId) => `${API_ROOT}/facilities/${facilityId}`;
export const facilityByIdOrSlugEndpoint = (facilityId) =>
    `${API_ROOT}/facilities/${facilityId}`;
export const facilityPassTypesOfflineEndpoint = (facilityId) =>
    `${API_ROOT}/facilities/${facilityId}/passtypes/offline`;
export const location = (id) =>
    `${process.env.API}/search?fq=entity_type%3Aactivitypass&fq=entity_id%3A${id}`;

// parent asset
export const recarea = (id) =>
    `${process.env.API}/search?fq=entity_type%3Arecarea&fq=entity_id%3A${id}`;
export const inventory = (id) => `${process.env.API}/external/inventory/asset/${id}`;

// accounts
export const verifyAddressEndpoint = () => `${process.env.API}/accounts/address/verify`;
